<!-- eslint-disable prettier/prettier -->
<template>
  <div>
    <PageHeader title="ตรวจสอบการเรียนผิดปกติ" />
    <b-container fluid="xl">
      <div class="py-5">
        <b-row class="mb-3" align-v="end">
          <b-col md="4" class="mb-3 mb-md-0">
            <label class="d-block font-weight-bold" style="font-size: 14px;">
              ชื่อผู้เรียน
            </label>
            <b-form-input
              v-model="filters.memberName"
              placeholder="ค้นหาชื่อผู้เรียน"
              @keyup.enter="fetchAbnormalUsageData(1)"
            ></b-form-input>
          </b-col>
          <b-col md="4" class="mb-3 mb-md-0">
            <label class="d-block font-weight-bold" style="font-size: 14px;">
              ชื่อคอร์สเรียน
            </label>
            <v-select
              v-model="filters.courseName"
              :options="courseOptions"
              placeholder="ค้นหาจากคอร์สเรียน..."
              taggable
              push-tags
              @search="(query) => { typedCourseSearch = query }"
              @input="(val) => { if (!val) typedCourseSearch = '' }"
            >
              <div slot="no-options">พิมพ์ชื่อคอร์สที่ต้องการค้นหา...</div>
            </v-select>
          </b-col>

          <b-col md="4" class="mb-3 mb-md-0">
            <label class="d-block font-weight-bold" style="font-size: 14px;">
              ประเภทความผิดปกติ
            </label>
            <b-form-select
              v-model="filters.behaviourType"
              :options="behaviourTypeOptions"
            ></b-form-select>
          </b-col>
        </b-row>

        <b-row class="mb-4">
          <b-col cols="6" md="3" lg="1">
            <b-button
              variant="primary"
              block
              class="font-weight-normal"
              @click="fetchAbnormalUsageData(1)"
            >
              ค้นหา
            </b-button>
          </b-col>
        </b-row>

        <!-- ตารางแสดงข้อมูลการเรียนผิดปกติ -->
        <b-table
          :fields="tableFields"
          :items="abnormalList.data"
          id="abnormal-list"
          :busy="isLoading"
          :per-page="perPage"
          responsive
          sort-icon-left
          table-class="mt-4 border-bottom"
          show-empty
        >
          <template #empty>
            <div class="text-center py-3 text-muted">ไม่พบข้อมูล</div>
          </template>

          <template #table-busy>
            <div class="text-center text-danger my-4">
              <Loading />
            </div>
          </template>

          <!-- คอลัมน์ต่าง ๆ -->
          <!-- วัน/เวลา -->
          <template #cell(aul_timestamp)="props">
            <div v-if="props.item.aul_timestamp">
              <span class="d-block">
                {{ formatThaiDate(props.item.aul_timestamp).date }}
              </span>
              <span class="d-block">
                {{ formatThaiDate(props.item.aul_timestamp).time }}
              </span>
            </div>
            <span v-else>-</span>
          </template>

          <!-- ชื่อผู้เรียน -->
          <template #cell(member_name)="props">
            {{ props.item.member_name || "-" }}
          </template>

          <!-- คอร์สเรียน -->
          <template #cell(c_name)="props">
            {{ props.item.c_name || "-" }}
          </template>

          <!-- บทเรียน -->
          <template #cell(lec_name)="props">
            {{ props.item.lec_name || "-" }}
          </template>

          <!-- บทเรียน -->
          <template #cell(aul_behaviourType)="props">
            {{ props.item.aul_behaviourType || "-" }}
          </template>

          <!-- รายละเอียด -->
          <template #cell(aul_behaviourDetail)="props">
            <div v-if="props.item.aul_behaviourDetail || props.item.aul_behaviourType === 'SCREEN_CAPTURE'">
              <span v-if="props.item.aul_behaviourDetail && props.item.aul_behaviourDetail.video_playback_speed" class="d-block">
                ความเร็ว {{ props.item.aul_behaviourDetail.video_playback_speed }}
              </span>
              <span v-if="props.item.aul_behaviourDetail && props.item.aul_behaviourDetail.watch_duration_seconds" class="d-block mt-1">
                เวลาเรียน {{ formatSecondsToHours(props.item.aul_behaviourDetail.watch_duration_seconds) }} ชั่วโมง
              </span>
              <span v-if="props.item.aul_behaviourType === 'SCREEN_CAPTURE' && props.item.aul_platform" class="d-block mt-1">
                {{ props.item.aul_platform }}
              </span>
            </div>
            <span v-else>-</span>
          </template>
        </b-table>

        <div class="row mt-3">
          <div class="col-lg-6">
            <form class="form-inline">
              <div class="form-group mb-2">
                <label>แสดง</label>
              </div>
              <div class="form-group ml-2 mb-2">
                <b-form-select
                  v-model="perPage"
                  :options="[10, 15, 30, 50]"
                  size="sm"
                  @input="setFetchParamsPerPage"
                ></b-form-select>
              </div>
              <div class="form-group ml-2 mb-2">
                <label>
                  จาก
                  {{ Number(abnormalList.total).toLocaleString() }}
                  รายการ
                </label>
              </div>
            </form>
          </div>
          <div class="col-lg-6">
            <nav class="float-right" aria-label="Page navigation example">
              <b-pagination
                v-model="currentPage"
                :total-rows="abnormalList.total"
                :per-page="perPage"
                @change="setFetchParamsPage"
                aria-controls="abnormal-list"
              ></b-pagination>
            </nav>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "@/components/layouts/PageHeader";
import Loading from "@/components/shared/Loading";
import api from "@/services/api.js";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "AbnormalUsagePage",
  components: { PageHeader, Loading, vSelect },
  data() {
    return {
      isLoading: false,
      perPage: 10,
      currentPage: 1,
      filters: {
        memberName: "",
        courseName: null,
        behaviourType: null
      },
      typedCourseSearch: "",
      behaviourTypeOptions: [
        { value: null, text: "ทั้งหมด" },
        { value: "ABNORMAL_VIDEO_SPEED", text: "เรียนความเร็วผิดปกติ" },
        { value: "SCREEN_CAPTURE", text: "บันทึกภาพหน้าจอ" }
      ],
      abnormalList: {
        data: [],
        total: 0
      },
      courseOptions: [],
      tableFields: [
        {
          key: "aul_timestamp",
          label: "วัน/เวลา",
          sortable: true,
          thStyle: { width: "12%" }
        },
        {
          key: "member_name",
          label: "ชื่อผู้เรียน",
          sortable: true,
          thStyle: { width: "18%" }
        },
        {
          key: "c_name",
          label: "คอร์สเรียน",
          sortable: true,
          thStyle: { width: "21%" }
        },
        {
          key: "lec_name",
          label: "บทเรียน",
          sortable: true,
          thStyle: { width: "21%" }
        },
        {
          key: "aul_behaviourType",
          label: "ประเภทความผิดปกติ",
          sortable: true,
          thStyle: { width: "18%" }
        },
        {
          key: "aul_behaviourDetail",
          label: "รายละเอียด",
          sortable: false,
          thStyle: { width: "10%" }
        }
      ]
    };
  },
  mounted() {
    this.fetchCourseOptions();
    this.fetchAbnormalUsageData();
  },
  methods: {
    async fetchCourseOptions() {
      try {
        const response = await api.get("/v1/abnormal-usage-logs/courses", {
          headers: {
            ComId: this.$store.state.Company.companyInfo.id
          }
        });
        this.courseOptions = response.data || [];
      } catch (error) {
        console.error("Error fetching course options:", error);
      }
    },

    async fetchAbnormalUsageData(page = this.currentPage) {
      this.isLoading = true;
      this.currentPage = page;

      try {
        const response = await api.get("/v1/abnormal-usage-logs", {
          params: {
            page: this.currentPage,
            limit: this.perPage,
            member_name: this.filters.memberName,
            course_name: this.filters.courseName || this.typedCourseSearch,
            behaviour_type: this.filters.behaviourType
          },
          headers: {
            ComId: this.$store.state.Company.companyInfo.id
          }
        });

        const rawData = response.data.data || [];

        // Merge first and last name into 'member_name' to enable sorting in b-table
        this.abnormalList.data = rawData.map(item => ({
          ...item,
          member_name: `${item.mp_firstName || ""} ${item.mp_lastName ||
            ""}`.trim()
        }));
        this.abnormalList.total = response.data.total || 0;
      } catch (error) {
        console.error("Error fetching abnormal usage data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    formatThaiDate(dateString) {
      if (!dateString || dateString === "-") return { date: "-", time: "" };
      const date = new Date(dateString);
      const datePart = date.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
      const timePart = date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit"
      });
      return { date: datePart, time: `${timePart} น.` };
    },

    formatSecondsToHours(seconds) {
      if (!seconds || isNaN(seconds)) return "0:00";
      const totalSeconds = Number(seconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const formattedMinutes = String(minutes).padStart(2, "0");
      return `${hours}:${formattedMinutes}`;
    },

    setFetchParamsPage(page) {
      this.fetchAbnormalUsageData(page);
    },

    setFetchParamsPerPage() {
      this.fetchAbnormalUsageData(1);
    }
  }
};
</script>

<style scoped>
/* Searchable dropdown */
::v-deep .v-select .vs__dropdown-toggle {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  background-color: #fff;
}

/* Selected options */
::v-deep .v-select .vs__selected-options {
  padding: 0;
  display: flex;
  align-items: center;
  height: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
}

/* Search input */
::v-deep .v-select .vs__search {
  margin: 0;
  padding: 0;
  line-height: 1.5;
  color: #495057;
}

/* Selected options */
::v-deep .v-select .vs__selected {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 100%;
}

/* Actions */
::v-deep .v-select .vs__actions {
  padding: 0;
  padding-right: 4px;
}

/* Clear and open indicator */
::v-deep .v-select .vs__clear,
::v-deep .v-select .vs__open-indicator {
  fill: #6c757d;
}

/* Adjust b-form-select height to match regular input */
::v-deep .custom-select {
  height: calc(1.5em + 0.95rem + 2px) !important;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  line-height: 1.5;
}
</style>
